module.exports = __webpack_public_path__ + "static/media/3DPPA29.529e9bd0.jpg";